$(document).ready(function () {
 
  // $('.background-video').bgVideo();
  // document.getElementById('bgvid').controls = false
  function titleWidth(){
    var h1LearnW = $('.h1_learn').innerWidth();
    var h1WorkW = $('.h1_work').innerWidth();
    var h1Width = Math.max(h1LearnW, h1WorkW);
    if(h1Width < 290){
      // var h1LearnW = $('.h1_learn').innerWidth();
      // var h1WorkW = $('.h1_work').innerWidth();
      $('.heroTitle').innerWidth(290);
      // debugger
    } else {
      // var h1LearnW = $('.h1_learn').innerWidth();
      // var h1WorkW = $('.h1_work').innerWidth();
      $('.heroTitle').innerWidth(h1Width);
    }
  }

  $(window).resize(function() {
    titleWidth();
  })
  titleWidth();

  function desktopAnimation(){
    var t1 = new TimelineMax();
    t1.to('.red-overlay', 1, {transform: 'matrix(1.9, -0.25881, 2, 1, 2, 285)', opacity: 1, ease:Linear.easeNone})
    .to('.click_holder', .5, {opacity: 1})
    .to('.h1_learn', .5, {opacity: 1, left: 0, ease:Linear.easeNone})
    .to('.h1_work', .5, {opacity: 1, left: 0, ease:Linear.easeNone})
    .to('.logo-wrapper', 1, {opacity: 1, ease:Linear.easeNone})
    .to('.lp-footer', 1, {opacity: 1, zIndex: 0, ease:Linear.easeNone})
    .to('.lp_complex-footer', 1, {opacity: 1, zIndex: 1, ease:Linear.easeNone});
    
  }  
  desktopAnimation();

  function removeVid(){
    var t2 = new TimelineMax();

    t2.to('.red-overlay', 0, {height: 80, top: 0, scaleY: 0, skewY: 0, ease:Linear.easeNone})
    .to(['.heroTitle', '.logo-wrapper', '.element-with-video-bg', '.click_holder'], .5, {opacity: 0, display: 'none'})
    .to('.logoMain-wrapper', .5, {opacity: 0})
    .to('.lp_nav', .2, {opacity: 1})
  }
 
  function removeVidLP(){
    var t2 = new TimelineMax();
    t2.to('.lp_complex .red-overlay', .2, {height: 80, top: 0, scaleY: 0, skewY: 0, ease:Linear.easeNone})
    .to('.lp_complex .lp_container-main', 0, {display: 'none'})
    .to(['.lp_complex .heroTitle', '.lp_complex .logo-wrapper', '.lp_complex .element-with-video-bg', '.lp_complex .click_holder'], .5, {opacity: 0, display: 'none'})
    .to('.lp_complex .logoMain-wrapper', .5, {opacity: 0})
    .to('.lp_complex .lp_nav', .5, {opacity: 1})
  }

  function enterContent(){
    var t3 = new TimelineMax();
    t3.to('.section-wrapper', 1, {display: 'block', opacity: 1, ease:Linear.easeNone})
    .to('.lp-footer_bkgnd', 1, {opacity: 1, ease:Linear.easeNone})
    var iconBox = new TimelineMax();
    setTimeout(function() {
      $('.icon_box').each(function() {
        iconBox.to(this, .08, {top: 0, opacity: 1})
      });
    }, 500)
  }
  
  function enterContentLP(){
    var t3 = new TimelineMax();
    t3.to('.lp_complex-footer .lp-footer_bkgnd', 2, {opacity: 1, ease:Linear.easeNone}).to('lp_container-main', 0, {backgroundColor: '#fff'}).to('.tsa_dynamic-spacer', .5, {margin:'100 auto 0', opacity: 1})
    $('html, body, form').css('background-color', '#fff');
    // $('body').css('overflow', 'hidden');
  }  

  function enterContentMob(){
    var footer = document.querySelector('.lp-footer');
    footer.style.zIndex = '-1';
    var t4 = new TimelineMax();
    t4.to('.section-wrapper', 1, {display: 'block', opacity: 1, top: 0, left: 0, transform: 'none', zIndex: 1, ease:Linear.easeNone})
    .to('.lp-footer_bkgnd', 1, {opacity: 1, ease:Linear.easeNone});    
    var iconBox = new TimelineMax();
    setTimeout(function() {
      $('.icon_box').each(function() {
        iconBox.to(this, .08, {top: 0, opacity: 1})
      });
    }, 500)
  }
  // //Event Listeners
  $('a.click_action').on("click", function () {
    removeVid();
    if($(window).width() > 768){
      enterContent();
    } else {
      enterContentMob();
    }
    this.classList.add('activated');
  });

  $('a.click_action-down').on("click", function () {
    removeVid();
    if($(window).width() > 768){
      enterContentLP();
    } else {
      enterContentMob();
    }
    this.classList.add('activated');
  });

  // $(window).scroll( function() {
  //   removeVidLP();
  //   enterContentLP();
  // })

  $( window ).resize(function() { 
    var w=window,
    d=document,
    e=d.documentElement,
    g=d.getElementsByTagName('body')[0],
    x=w.innerWidth||e.clientWidth||g.clientWidth,
    y=w.innerHeight||e.clientHeight||g.clientHeight;
    var mobileHeader = document.querySelector('.section-wrapper');
    var courseFinderActive = document.querySelector('a.activated')
    if(x < 767){
      // mobileHeader.style.margin = '53px 0'; 
      if(mobileHeader){
        mobileHeader.setAttribute('style', 'margin: 45px 0; display: block; opacity: 1;');
      }  
    } else if (courseFinderActive){
      // mobileHeader.setAttribute('style', "top: 50%; left: 50%; -webkit-transform: translateX(-50%) translatey(-50%); transform: translateX(-50%) translatey(-50%); display: block; opacity: 1;");
      mobileHeader.setAttribute('style', "top: 50%; transform: translatey(-50%); display: block; opacity: 1;");
    }
  });
});